import React from 'react'

function WorkingProcessThree() {
  return (
    <div>
        

        {/* Tmp Servisec Processs Area Two Start */}
        <div className="tpm-services-process-area tmp-section-gap bg-working-1">
            <div className="container">
            <div className="row">
                <div className="col-lg-12">
                <div className="section-head">
                    <div className="section-sub-title center-title">
                    <img
                        src="assets/images/services/section-custom-menubar.png "
                        alt="Corporate_service"
                    />
                    <span className="subtitle">OUR work process</span>
                    </div>
                    <h2 className="title split-collab">How our services work</h2>
                </div>
                </div>
            </div>
            <div className="row g-5">
                <div className="col-lg-4 col-md-6 col-sm-12 col-12">
                <div className="single-services">
                    <div className="services-inner">
                    <div className="thumbnail thumbnail-rounded border-top-left hover-animation">
                        <a href="#">
                        <img
                            src="assets/images/services/services-round-1.png"
                            alt="Business consulting services"
                        />
                        </a>
                        <div className="number-bg-round">
                        <span>01</span>
                        </div>
                    </div>
                    <div className="services-content services-content-style-1 text-center">
                        <h5 className="title">Client Consultation</h5>
                        <p style={{textAlign:"justify"}} className="description">
                        We begin with understanding your business goals, challenges, and regulatory needs to align our services with your financial strategy.


                        excuse.
                        </p>
                    </div>
                    </div>
                </div>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12 col-12">
                <div className="single-services">
                    <div className="services-inner">
                    <div className="thumbnail thumbnail-rounded border-top-left hover-animation">
                        <a href="#">
                        <img
                            src="assets/images/services/services-round-2.png"
                            alt="Business consulting services"
                        />
                        </a>
                        <div className="number-bg-round">
                        <span>02</span>
                        </div>
                    </div>
                    <div className="services-content services-content-style-1 text-center">
                        <h5 className="title">Data Collection</h5>
                        <p style={{textAlign:"justify"}} className="description">
                        Our team gathers necessary financial and operational data to ensure accurate compliance and timely submissions.
                        </p>
                    </div>
                    </div>
                </div>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12 col-12">
                <div className="single-services">
                    <div className="services-inner">
                    <div className="thumbnail thumbnail-rounded border-top-left hover-animation">
                        <a href="#">
                        <img
                            src="assets/images/services/services-round-3.png"
                            alt="Business consulting services"
                        />
                        </a>
                        <div className="number-bg-round">
                        <span>03</span>
                        </div>
                    </div>
                    <div className="services-content services-content-style-1 text-center">
                        <h5 className="title">Process Implementation</h5>
                        <p style={{textAlign:"justify"}} className="description">
                        We implement solutions, streamline reporting, and ensure your systems meet audit and compliance standards.
                        </p>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            </div>
        </div>
        {/* Tmp Servisec Processs Area Two End */}


    </div>
  )
}

export default WorkingProcessThree